<div class="main-tab-title-box">
    <mat-card-title class="main-title">Errors: {{currentEnglishType}}</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>

<div *ngIf="loaderActive" class="div_loader_pag">
    <div  id="div_loader_pag">
      <div  class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysis will begin after you finish typing</div>
  </div>
  <div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
    <div  id="div_loader_pag">
      <div  class="loader_pag"></div>
    </div>
    <div class="main-box-title-12">Analysing and Saving</div>
  </div>
  <div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>

<mat-card-content>
    <span class="main-box-title-14">Your text is currently being checked for errors in {{currentEnglishType}}. You can change the English type in the "Analysis Options" above.</span>
    <br>
    <br>
    <!-- <div *ngIf="englishType === 'british'" class="box-british">
        <mat-checkbox color="accent" [checked]="true" style="padding-bottom: 5px;" disableRipple>
        </mat-checkbox>
       <div class="main-box-title-16"> Also accept “-ize” endings (e.g. emphasise as well as emphasize)</div>
    </div> -->
    <div class="errors-box" style="grid-column: span 2;">
        <div class="errors-box-sub" style="grid-column: span 2;">
            <div class="main-box-title-14" style="display: flex; align-items: center;">
                <div class="tooltip-container">
                <button class="button-seeAll" 
                        (click)="!(isButtonDisabled() || errors.words.length === 0)  && toggleSeeAll()" 
                        [disabled]="isButtonDisabled() || errors.words.length === 0 "
                        [ngClass]="{
                            'disabled-button': isButtonDisabled() || errors.words.length === 0
                        }">
                    <img class="see-all-icon eye-icon" style="padding-left: 6px;" [src]="seeAllIconSrc">
                    <span class="main-box-title-12">See All</span>
                </button>

                <!-- Tooltip si está deshabilitado -->
                <span class="tooltip-text" 
                        *ngIf="results && errors.words.length === 0">
                    In this text, there are no words to show in this category.
                </span>
                </div>
                Spelling errors total
            </div>
            <div class="main-box-value-16-bold" >{{errors.words.length}}<button class="button-amend"><img class="edit-icon" src="./assets/images/project-icon.svg"></button></div>
        </div>
        <div id="listado" *ngIf="errors.words.length > 0">
            <ng-container *ngFor="let item of errors.words; let i = index">
                <div class="item-listado-errores" [class.highlighted]="ishighlighted[i]" (click)="toggleEyeIcon(i, item)">
                    <img class="eye-icon" [src]="ishighlighted[i] ? './assets/images/yellow_icons/eye-on-icon.svg' : './assets/images/eye-icon.svg'">{{item}}
                </div>
            </ng-container>
        </div>
    </div>

    <div class="horizontal-box">
            <div class="main-box-title-14"> Spelling errors per sentence</div>
            <div class="main-box-value-16-bold">{{errors.errors_sentence}}</div>
    </div>
    
    <div class="horizontal-box">
            <div class="main-box-title-14"> Spelling errors per 100 words</div>
            <div class="main-box-value-16-bold">{{errors.errors_words}}</div>
    </div>

</mat-card-content>
